import { Navigate, type RouteObject } from 'react-router-dom'
import { RedeemPage } from './RedeemPage'
import { RedemptionsPage } from './RedemptionsPage'
import { BankReturnPage } from './BankReturnPage'
import { PartnerCreditsPage } from './PartnerCreditsPage'
import { TravelPage, TripNewPage, TripPage } from './TravelPages'
import { PARTNER_CREDITS } from './flags'

export { PARTNER_CREDITS } from './flags'

export const routes: RouteObject[] = [
  { path: '/redeem', element: <RedeemPage /> },
  { path: '/redemptions', element: <RedemptionsPage /> },
  { path: '/travel', element: <TravelPage /> },
  { path: '/travel/new', element: <TripNewPage /> },
  { path: '/travel/:id', element: <TripPage /> },
  { path: '/bank-return', element: <BankReturnPage /> },
  { path: '/partner/credits', element: PARTNER_CREDITS ? <PartnerCreditsPage /> : <Navigate to="/partner" replace /> },
]
